const introPoints = [
  '堅持自然選材，以自然為根本',
  '配方研發、生產製造、品質管理，提供一條龍服務',
  '服務超過 250 個品牌客戶，生產產品總數超過千項',
  '提供彈性化客製方案，滿足您的需求',
];

const brandValues = [
  { icon: 'ri-heart-pulse-line', title: '健康優先', desc: '以消費者健康為核心，嚴格把關每個製程環節。' },
  { icon: 'ri-lightbulb-line', title: '持續創新', desc: '追蹤全球生技趨勢，持續導入新原料與新技術。' },
  { icon: 'ri-shield-check-line', title: '品質承諾', desc: '每批次產品均有完整檢驗報告，確保穩定品質。' },
  { icon: 'ri-group-line', title: '夥伴精神', desc: '視客戶為長期夥伴，提供超越代工的顧問支援。' },
];

export default function CompanyIntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">

        {/* Section header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            認識康永
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            以 自然 為基礎，以品質為承諾
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技是台灣專業的保健食品 ODM／OEM 代工廠，結合研發實力與製造經驗，成為品牌成長最可靠的後盾
          </p>
        </div>

        {/* Image + text */}
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16 mb-20">
          {/* Left text */}
          <div className="w-full lg:w-1/2">
            <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-8">
              康永生技自創立以來，始終以「 天然、品質、專業 」為核心價值，致力於為保健食品品牌提供最完整的代工服務。服務範圍從配方研發到生產出貨，讓客戶專注於品牌經營，其餘交給康永。
            </p>
            <ul className="space-y-3">
              {introPoints.map((point) => (
                <li key={point} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg" />
                  </div>
                  <span className="text-[#1a2e1a] text-[0.9375rem] leading-[1.75]">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=team%20of%20professional%20biotech%20scientists%20researchers%20discussing%20in%20modern%20laboratory%20with%20plants%20herbs%20ingredients%20on%20table%2C%20collaborative%20meeting%20environment%2C%20natural%20lighting%2C%20health%20supplement%20company%20team&width=720&height=500&seq=about-company-01&orientation=landscape"
                alt="康永生技團隊"
                className="w-full h-[360px] lg:h-[420px] object-cover object-top rounded-2xl"
              />
              <div className="absolute bottom-5 right-5 bg-white/95 rounded-xl px-5 py-3 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-green-50 rounded-lg">
                  <i className="ri-building-2-line text-[#4CAF50] text-lg" />
                </div>
                <div>
                  <p className="text-[#1a2e1a] font-bold text-[0.9375rem]">多年代工經驗</p>
                  <p className="text-gray-400 text-[0.75rem]">深耕台灣生技產業</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Brand values grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {brandValues.map((v) => (
            <div key={v.title} className="bg-[#f7faf7] rounded-2xl p-6 text-center hover:border-green-200 border border-transparent hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mx-auto mb-4 border border-green-100">
                <i className={`${v.icon} text-[#4CAF50] text-2xl`} />
              </div>
              <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{v.title}</h3>
              <p className="text-gray-500 text-[0.875rem] leading-[1.75]">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}